import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { sendSatisfy } from 'modules/actions/starScore';
import './style.scss';
const ServiceGuide = () => {
  const dispatch = useDispatch();
  const closeServiceGuide = () => {
    dispatch(disableAllMenu());
    // setPayloadStatus({ score: 5, name: '매우만족', content: '', status: 'N' });
  };
  const [displayStatus, setDisplayStatus] = useState({ guide: true, auto: false });

  // // state
  // const [payloadStatus, setPayloadStatus] = useState({ score: 5, name: '매우만족', content: '' });
  // const StarName = ['매우불편', '불편', '보통', '만족', '매우만족'];

  // // event
  const changeDisplay1 = () => {
    setDisplayStatus({ guide: true, auto: false });
  };
  const changeDisplay2 = () => {
    setDisplayStatus({ guide: false, auto: true });
  };

  // const setContentValue = contentStr => {
  //   if (contentStr) {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'Y' });
  //   } else {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'N' });
  //   }
  // };
  return (
    <div className="help_area">
      <div className="help_header">
        <span>이용 안내</span>
        <i className="ri-close-line" onClick={closeServiceGuide} />
      </div>
      <div className="help_tab_area">
        <div
          className="help_tab"
          onClick={changeDisplay1}
          style={{
            borderBottom: displayStatus.guide ? '2px #0061af solid' : '',
            color: displayStatus.guide ? '#0061af' : '',
          }}
        >
          챗봇 화면 안내
        </div>
        <div
          className="help_tab"
          onClick={changeDisplay2}
          style={{
            borderBottom: displayStatus.auto ? '2px #0061af solid' : '',
            color: displayStatus.auto ? '#0061af' : '',
          }}
        >
          질문 자동 완성
        </div>
      </div>
      <div className="help_content">
        <img src="/chat/ibricks/images/help_01.png" alt="" className="img_help" style={{ display: displayStatus.guide ? 'inline-block' : 'none' }} />
        <img src="/chat/ibricks/images/help_02.png" alt="" className="img_help" style={{ display: displayStatus.auto ? 'inline-block' : 'none' }} />
      </div>
    </div>
  );
};

export default ServiceGuide;
